var colTracker = [];
/**
 * Set appropriate spanning to any masonry item
 *
 * Get different properties we already set for the masonry, calculate
 * height or spanning for any cell of the masonry grid based on its
 * content-wrapper's height, the (row) gap of the grid, and the size
 * of the implicit row tracks.
 *
 * @param item Object A brick/tile/cell inside the masonry
 */

function resizeMasonryItem(grid, item, colIndex, rowStart, rowSpan) {
  // Only set grid placement, not height
  item.style.gridColumnStart = colIndex + 1;
  item.style.gridRowStart = rowStart;
}

/**
 * Apply spanning to all the masonry items
 *
 * Loop through all the items and apply the spanning to them using
 * `resizeMasonryItem()` function.
 *
 * @uses resizeMasonryItem
 */
function resizeAllMasonryItems(selectors) {
  var grids = document.querySelectorAll(selectors);

  grids.forEach((grid) => {
    grid.style.rowGap = 0;
    grid.style.height = null;
    grid.style.gridTemplateRows = null;
    grid.style.overflowY = null; // reset

    var allItems = grid.querySelectorAll(":scope > *");
    for (let i = 0; i < allItems.length; i++) {
      allItems[i].style.gridColumnStart = null;
      allItems[i].style.gridRowStart = null;
      allItems[i].style.height = null;
    }

    var colCount = window
      .getComputedStyle(grid)
      .getPropertyValue("grid-template-columns")
      .split(" ").length;

    // Get row height from CSS if possible, fallback to 15
    let rowHeight = 15;
    let computedRowHeight = window
      .getComputedStyle(grid)
      .getPropertyValue("grid-auto-rows");
    if (computedRowHeight) {
      let parsed = parseInt(computedRowHeight);
      if (!isNaN(parsed)) rowHeight = parsed;
    }

    let colHeights = new Array(colCount).fill(0);
    let rowHeights = new Array(colCount).fill(1);
    let maxBottomPx = 0;
    for (let i = 0; i < allItems.length; i++) {
      let item = allItems[i];
      // Force reflow to ensure accurate height
      item.offsetHeight;
      let itemHeight = item.getBoundingClientRect().height;
      let rowSpan = Math.ceil(itemHeight / rowHeight);
      // Find the shortest column (including 3-row gap if not first item)
      let minCol = 0;
      let minHeight = Infinity;
      for (let c = 0; c < colCount; c++) {
        let gap = rowHeights[c] > 1 ? 3 * rowHeight : 0;
        let totalHeight = colHeights[c] + gap;
        if (totalHeight < minHeight) {
          minCol = c;
          minHeight = totalHeight;
        }
      }
      let gapRows = rowHeights[minCol] > 1 ? 3 : 0;
      let rowStart = rowHeights[minCol] + gapRows;
      resizeMasonryItem(grid, item, minCol, rowStart, rowSpan);
      colHeights[minCol] += rowSpan * rowHeight + gapRows * rowHeight;
      rowHeights[minCol] += rowSpan + gapRows;
      let itemBottomPx = (rowStart - 1) * rowHeight + rowSpan * rowHeight;
      maxBottomPx = Math.max(maxBottomPx, itemBottomPx);
    }

    grid.style.height = `${maxBottomPx}px`;
    let maxRows = Math.ceil(maxBottomPx / rowHeight);
    grid.style.gridTemplateRows = `repeat(${maxRows}, ${rowHeight}px)`;
  });
}
// target elements
window.addEventListener("DOMContentLoaded", () => {
  resizeAllMasonryItems(".masonry-grid");
});

window.addEventListener("resize", () => {
  resizeAllMasonryItems(".masonry-grid");
});
